import { useState } from 'react';
import { Download, Music2 } from 'lucide-react';
import { useLang } from './i18n';

/** Authenticated attachment URL stays the same as download; playback never autostarts. */
export function AudioPlayer({ src, name }: { src: string; name: string }) {
  const [, , tr] = useLang();
  const [failedSource, setFailedSource] = useState('');
  return <div className="attachment-audio">
    <div className="attachment-audio-heading">
      <Music2 size={19} aria-hidden="true" />
      <span className="attachment-audio-name" title={name}>{name}</span>
      <a href={src} download={name} className="attachment-audio-download" aria-label={tr('Download audio', 'Audiodatei herunterladen')}><Download size={17} aria-hidden="true" /></a>
    </div>
    <audio key={src} src={src} controls preload="metadata" aria-label={tr('Play audio: ', 'Audiodatei abspielen: ') + name} onError={() => setFailedSource(src)} />
    {failedSource === src && <p role="status">{tr('This file cannot be played here. You can still download it.', 'Diese Datei lässt sich hier nicht abspielen. Du kannst sie weiterhin herunterladen.')}</p>}
  </div>;
}
